import { render, staticRenderFns } from "./pageBanner.vue?vue&type=template&id=3cbf318c&scoped=true"
import script from "./pageBanner.vue?vue&type=script&lang=js"
export * from "./pageBanner.vue?vue&type=script&lang=js"
import style0 from "./pageBanner.vue?vue&type=style&index=0&id=3cbf318c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbf318c",
  null
  
)

export default component.exports